module.exports = __webpack_public_path__ + "media/O_illustration.de026725.mp3";